export const DriveTypeIds = {
    home: 0,
    important: 4,
    share: 5
}

export const DriveCommon = {
    layout_type: {
        grid: 'grid',
        list: 'list'
    }
}